<template>
  <div class="w-full pr-3 text-gray-dark flex items-center justify-between">
      <span>Delete {{ sentenceEnd }}</span>
      <div class="flex items-center">
        <base-button variant="transparent"
                     icon="close"
                     icon-size="1.5rem"
                     class="flex items-center text-gray-dark"
                     id="cancel-button"
                     @click="$emit('update-mode', EXAMPLE_EDITOR_MODE.BULK)"
        />
        <busy-button variant="transparent-error"
                     icon="done"
                     icon-size="1.5rem"
                     class="flex items-center text-gray-dark"
                     :id="intentDeleteButtonId"
                     :is-loading="isBusy"
                     @click="$emit('delete-examples')"
        >
          <span class="ml-1">Delete</span>
        </busy-button>
      </div>
    </div>
</template>

<script>
import { EXAMPLE_EDITOR_MODE } from '@/store/constants'
import BusyButton from '@/components/common/BusyButton'
import { BUSY_BUTTONS } from '@/utils/busy-buttons.constants'
import busyButtonsModule from '@/store/modules/busy-buttons.module'

export default {
  name: 'IntentExamplesHeaderBulkDelete',
  components: {
    BusyButton
  },
  props: {
    selectedExamplesCount: {
      type: Number
    }
  },
  data() {
    return {
      EXAMPLE_EDITOR_MODE,
      intentDeleteButtonId: BUSY_BUTTONS.INTENT_DELETE
    }
  },
  computed: {
    isBusy() {
      return busyButtonsModule.isButtonBusy(this.intentDeleteButtonId)
    },

    sentenceEnd() {
      return `${this.selectedExamplesCount} ${this.selectedExamplesCount === 1 ? 'example' : 'examples'}?`
    }
  }
}
</script>
